// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"107":"6ff59b7a","457":"d00ecc56"}[chunkId] + ".chunk.css";
};